import React from 'react';
import LinkFulfilled from '../../uiKit/links/fulfilled';
import { useTranslation } from 'react-i18next';

export default React.memo(function GameDescriptionBlock({ game }) {
  const { t } = useTranslation('common');

  // const canShare = Boolean(navigator.share);
  //
  // const shareLink = async () => {
  //   try {
  //     await navigator.share({
  //       title: game.name,
  //       text: 'Play & win',
  //       url: window.location.href,
  //     })
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const blocks = [
    { label: t('labels.volatility'), value: game.volatility },
    { label: t('labels.rtp'), value: game.rtp },
    { label: t('labels.theme'), value: game.theme },
    { label: t('labels.release_date'), value: game.releaseDate.split('T')[0].replace(/-/g, '/') }
  ];

  return (
    <div className={'w-full grid grid-cols-1 lg:grid-cols-2 lg:grid-rows-1 gap-8'}>
      <div className={'px-[3.625rem] py-1 max-h-[34rem]'}>
        <img src={game.iconSquare} alt={`${game.name} icon`} className={'h-full w-full object-contain rounded-[2.5rem]'} />
      </div>

      <div className={'flex flex-col gap-10'}>
        <div className={'flex flex-col gap-4'}>
          <div className={'flex flex-wrap gap-4'}>
            {game.gameTypes.map(type =>
              <span key={type}
                    className={'bg-white/10 border border-white/20 rounded-[6.25rem] px-2 py-0.5 leading-loose text-white'}>
                {type}
              </span>
            )}
          </div>

          <h1 className={'text-white text-[3.5rem] leading-snug font-medium'}>
            {game.name}
          </h1>

          <p className={'text-lg text-white line-clamp-4'}>
            {game.overview}
          </p>
        </div>

        <div className={'w-full flex flex-wrap gap-4'}>
          {blocks.map(({ label, value }) =>
            <div key={label} className={'flex flex-col gap-1.5 bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white text-center leading-none flex-1'}>
              <span className={'text-xs'}>{label}</span>
              <span className={'font-extrabold text-sm uppercase'}>{value}</span>
            </div>
          )}
        </div>

        <LinkFulfilled external className={'!bg-white w-max px-4 py-2 !rounded-lg text-black'} to={game.demoLink} target={'_blank'}
                       rel={'noopener noreferrer'}>
          {t('buttons.try_now')}
        </LinkFulfilled>
      </div>
    </div>
  );
})
